import styled from "styled-components";
import { tokens, palette } from "@plataforma/components";

export const Profile = styled.div`
  display: flex;
  align-items: center;
`;

export const Data = styled.div`
  flex-grow: 1;
  min-width: 1px;
  margin-right: ${tokens.spacing.s};
`;

export const Name = styled.h2`
  ${tokens.font.s};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  margin: 0 0 ${tokens.spacing.xs};
  color: ${palette['color-dark']};
  font-weight: ${tokens.font.weight.semibold};

  &:empty {
    display: none;
  }
`;

export const Email = styled.p`
  ${tokens.font.xs};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  margin: 0 0 ${tokens.spacing.xs};
  color: ${palette['color-grey-500']};

  &:empty {
    display: none;
  }
`;